import { request } from 'axios/request';
import { toQueryString } from 'theme/utils';
import { moveBasket, removeBasketItems } from './basket';

import {
  FETCH_CUSTOMER_LIST_PENDING,
  FETCH_CUSTOMER_LIST_REJECTED,
  FETCH_CUSTOMER_LIST_FULFILLED,
} from 'constants/customerList';

import { REMOVE_CUSTOMER_DETAIL } from 'constants/customerDetail';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_CUSTOMER_LIST_PENDING,
});

const fulfilled = (response) => ({
  type: FETCH_CUSTOMER_LIST_FULFILLED,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_CUSTOMER_LIST_REJECTED,
  error: error,
});

export const fetchCustomers = (value, currentPage) => (dispatch) => {
  dispatch(pending());
  const qs = toQueryString(value);

  request({
    method: 'get',
    url: `${$U.CUSTOMER_LIST}${qs}&page=${currentPage}`,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const customerLogout = (keepBasket) => (dispatch) => {
  request({
    url: $U.CUSTOMER_LOGOUT,
    method: 'POST',
    data: {},
  })
    .then(() => {
      dispatch({ type: REMOVE_CUSTOMER_DETAIL });
      if (keepBasket) {
        dispatch(moveBasket());
      } else {
        dispatch(removeBasketItems());
      }
    })
    .catch(() => {
      dispatch({ type: REMOVE_CUSTOMER_DETAIL });
    });
};



// WEBPACK FOOTER //
// ./src/actions/customerList.js